/**
 * Tiny ref-counted body scroll lock.
 *
 * Why a shared counter instead of inlined save/restore in each overlay:
 * if two overlays are open at once and the inner one closes first, a naive
 * save/restore would restore "" while the outer overlay is still up, leaving
 * the page scrollable behind it. The counter also makes leaks visible — the
 * lock only fully releases when every acquire has called its release fn.
 *
 * Each acquire() returns an idempotent release fn so React effect cleanups
 * can call it more than once safely.
 */
let count = 0;
let original = "";

export function acquireBodyScrollLock() {
  if (count === 0) {
    original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  count += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    count = Math.max(0, count - 1);
    if (count === 0) document.body.style.overflow = original;
  };
}
